export default "__VITE_ASSET__9sGgvHlC__"